<template>
  <bar :chartdata="chartdata" :options="options"/>
</template>

<script>
import Bar from '@/components/charts/bar'

export default {
  name: 'ToolsBearseFeatures',
  components: {
    Bar
  },
  props: {
    deployedFeatures: {
      type: Object,
      default: () => {}
    },
    accounts: {
      type: Array,
      default: () => []
    },
    features: {
      type: Object,
      default: () => []
    }
  },
  data () {
    return {
      chartdata: null,
      options: {
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              return `${tooltipItem.yLabel} accounts`
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Accounts'
            },
            ticks: {
              beginAtZero: true
            }
          }],
          xAxes: [{
            gridLines: {
              display: false
            }
          }]
        }
      }
    }
  },
  methods: {
    fillchartdata: function () {
      const deployedDataset = []
      const outdatedDataset = []

      const deployedFeatures = (typeof this.deployedFeatures !== 'undefined' ? this.deployedFeatures : {})
      const bearseFeatures = Object.keys(this.features)

      for (const feature of bearseFeatures) {
        if (feature in deployedFeatures) {
          const outdated = deployedFeatures[feature].filter(obj => {
            return obj.outdated === true
          })
          const uniqueOutdated = [...new Set(outdated.map(item => item.account_id))]
          outdatedDataset.push(uniqueOutdated.length)

          const uniqueDeployed = [...new Set(deployedFeatures[feature].map(item => item.account_id))]
          deployedDataset.push(uniqueDeployed.length)
        } else {
          deployedDataset.push(0)
          outdatedDataset.push(0)
        }
      }

      this.chartdata = {
        labels: bearseFeatures,
        datasets: [
          {
            label: 'deployed',
            data: deployedDataset,
            backgroundColor: '#118ab2'
          },
          {
            label: 'outdated',
            data: outdatedDataset,
            backgroundColor: '#ef476f'
          }
        ]
      }
    }
  },
  created: function () {
    this.fillchartdata()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/ToolsBearseFeatures.vue